import { useOthers } from "@configs/liveblocks.config"
import { useMemo } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import UserAvatarStack from "@molecules/UserAvatarStack/UserAvatarStack"

import styles from "./NavTopBarPagePresence.module.scss"

const DESKTOP_AVATAR_LIMIT = 3
const MOBILE_AVATAR_LIMIT = 2

export default function NavTopBarPagePresence() {
    const others = useOthers()

    const isDesktop = useIsDesktop()

    // The stack shows who else is on the page, so the current user is left out of it. The Liveblocks userId is
    // stable per real user, so a user with multiple open tabs appears once per connection; dedupe on the id so each
    // real user shows a single time. Entries without an id can't be deduped and always pass through.
    const users = useMemo<AvatarUser[]>(() => {
        const seenUserIds = new Set<string>()
        return others
            .map((other) => ({ ...other.info, id: other.id }))
            .filter((avatarUser) => {
                if (avatarUser.id == null) {
                    return true
                }
                const userId = String(avatarUser.id)
                if (seenUserIds.has(userId)) {
                    return false
                }
                seenUserIds.add(userId)
                return true
            })
    }, [others])

    if (users.length > 0) {
        return (
            <div className={styles.pagePresence}>
                <UserAvatarStack
                    users={users}
                    limit={isDesktop ? DESKTOP_AVATAR_LIMIT : MOBILE_AVATAR_LIMIT}
                    avatarSize="xl"
                    isLive={true}
                />
            </div>
        )
    } else {
        return null
    }
}
